import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { BrandLogo } from "../../components/BrandLogo";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-brand-dark grain flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8"><BrandLogo dark size="text-4xl" /></div>
        <div className="bg-brand-cream rounded-3xl p-6 shadow-2xl">
          <h1 className="font-head text-2xl font-bold text-brand-dark">Staff login</h1>
          <p className="text-sm text-brand-dark/50 mb-5">The Bettle & Chisel admin dashboard</p>
          <form onSubmit={submit} className="space-y-4">
            <div><Label className="text-xs">Email</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 h-12 rounded-xl bg-white" /></div>
            <div><Label className="text-xs">Password</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 h-12 rounded-xl bg-white" /></div>
            {error && <p className="text-sm text-red-500" data-testid="login-error">{error}</p>}
            <Button data-testid="login-submit" type="submit" disabled={loading}
              className="w-full h-12 rounded-xl bg-brand-teal hover:bg-brand-teal-dark text-white font-bold">
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
